import React from 'react'
import scrollTo from '../../../util/ScrollTo'
import './scrollToTopButton.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'


class ScrollToTopButton extends React.PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      shouldShow: false,
      lastScroll: 0,
      ticking: false,
    }
    this.scroll = this.scroll.bind(this)
  }
  componentDidMount() {
    window.addEventListener('scroll', this.scroll, false)
  }
  componentWillUnmount() {
    window.removeEventListener('scroll', this.scroll, false)
  }
  scroll(e) {
    if (!this.state.ticking) {
      window.requestAnimationFrame(() => {
        const shouldShow = window.scrollY < this.state.lastScroll && window.scrollY > 300
        this.setState({
          ticking: false,
          lastScroll: window.scrollY,
          shouldShow
        })
      })
      this.setState({
        ticking: true
      })
    }
  }

  render() {
    const {shouldShow} = this.state
    let classNames = `scroll-to-top-button ${this.props.className}`
    if (shouldShow) {
      classNames = `${classNames} scroll-to-top-button--enabled`
    }
    return (
      <div
        onClick={()=>{
          scrollTo(0, 400)
        }}
        className={classNames} >
        <FontAwesomeIcon icon={['fa', 'angle-up']} />
        TOP
      </div>
    )
  }
}

export default ScrollToTopButton



// WEBPACK FOOTER //
// ./src/core/components/scroll-to-top-button/ScrollToTopButton.js